import { render, staticRenderFns } from "./customers_search.vue?vue&type=template&id=5c358323&scoped=true&"
import script from "./customers_search.vue?vue&type=script&lang=js&"
export * from "./customers_search.vue?vue&type=script&lang=js&"
import style0 from "./customers_search.vue?vue&type=style&index=0&id=5c358323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c358323",
  null
  
)

export default component.exports